import { createContext } from 'react';

import { StorageSnapshot } from '@totem/components/administration/storageReporting/types';

interface Context {
  loading: boolean;
  snapshot: StorageSnapshot | null;
  onRefresh: () => void;
}

export default createContext<Context>({
  loading: false,
  snapshot: null,
  onRefresh: () => {},
});
